var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSecure)?_c('em',[_vm._v(_vm._s(_vm.$t('jwt')))]):_vm._e(),_c('ul',_vm._l((_vm.list),function(element){return _c('li',{key:element[_vm.attr]},[_vm._v(_vm._s(element[_vm.attr]))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }